var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-common',{class:[_vm.s.buttonAttach, _vm.s.buttonIcon],attrs:{"type":_vm.type,"size":_vm.size},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }